export const menuCategories = [
  { id: 'bites', name: 'Bread & Bites', icon: 'cookie' },
  { id: 'cakes', name: 'Cakes', icon: 'cake' },
  { id: 'event', name: 'Event Cakes', icon: 'gift' },
  { id: 'drinks', name: 'Drinks', icon: 'coffee' },
];

export const allMenuItems = [
  // Bread & Bites (from menu image)
  { name: 'Sambusa (Beef)', price: 1000, description: 'Crispy savory pastry', category: 'bites' },
  { name: 'Kabab', price: 1000, description: 'Grilled meat skewer', category: 'bites' },
  { name: 'Maandazi', price: 500, description: 'Sweet fried dough', category: 'bites' },
  { name: 'Maandazi (Packet)', price: 2000, description: 'Pack of maandazi', category: 'bites' },
  { name: 'Egg chop', price: 1500, description: 'Egg-wrapped delight', category: 'bites' },
  { name: 'Cutlets', price: 1000, description: 'Savory cutlet', category: 'bites' },
  { name: 'Chapati', price: 500, description: 'Soft flatbread', category: 'bites' },
  { name: 'Half cake', price: 500, description: 'Small cake portion', category: 'bites' },
  { name: 'Milk bread loaf (Small)', price: 2500, description: 'Soft white bread', category: 'bites' },
  { name: 'Milk bread loaf (Large)', price: 4000, description: 'Family-size loaf', category: 'bites' },
  { name: 'Pizza (Medium)', price: 10000, description: 'Fresh baked pizza', category: 'bites' },
  { name: 'Pizza (Large)', price: 15000, description: 'Large pizza for sharing', category: 'bites' },
  { name: 'Pizza (Slice)', price: 3000, description: 'Single pizza slice', category: 'bites' },
  { name: 'Banana Bread (Small)', price: 6000, description: 'Moist fruit bread', category: 'bites' },
  { name: 'Banana Bread (Large)', price: 10000, description: 'Large moist fruit bread', category: 'bites' },
  { name: 'Cupcakes', price: 500, description: 'Individual delights', category: 'bites' },
  { name: 'Friday cake - rojo', price: 10000, description: 'Special weekly offer', category: 'bites' },
  { name: 'Cake slice', price: 5000, description: 'Single serving delight', category: 'bites' },
  // Cakes
  { name: 'Bento 1/4kg cake', price: 30000, description: 'Perfect gift size', category: 'cakes' },
  { name: '1/2 KG CAKE', price: 40000, description: 'Perfect for small celebrations', category: 'cakes' },
  { name: '1 KG CAKE', price: 60000, description: 'Ideal for family gatherings', category: 'cakes' },
  { name: '2 KG CAKE', price: 110000, description: 'Perfect for larger celebrations', category: 'cakes' },
  { name: '3 KG CAKE', price: 150000, description: 'For grand celebrations', category: 'cakes' },
  { name: '6 BENTO CUPCAKES', price: 30000, description: 'Cupcake gift box', category: 'cakes' },
  { name: '12 BENTO CUPCAKES', price: 50000, description: 'Large cupcake box', category: 'cakes' },
  // Event Cakes
  { name: 'Basic Package', price: null, description: 'Simple elegant design', category: 'event', custom: true },
  { name: 'Standard Package', price: null, description: 'Beautiful decorations included', category: 'event', custom: true },
  { name: 'Premium Package', price: null, description: 'Luxury cake experience', category: 'event', custom: true },
  { name: 'Luxury Package', price: null, description: 'Ultimate celebration cake', category: 'event', custom: true },
  // Drinks
  { name: 'Hot Milk', price: 1500, description: 'Warm comforting milk', category: 'drinks' },
  { name: 'Swahili Spice Brew', price: 1500, description: 'Traditional spiced tea', category: 'drinks' },
  { name: 'Chai latte', price: 3000, description: 'Creamy spiced chai', category: 'drinks' },
  { name: 'Hot chocolate', price: 3500, description: 'Rich cocoa drink', category: 'drinks' },
  { name: 'Coffee', price: 3000, description: 'Fresh brewed coffee', category: 'drinks' },
  { name: 'Fresh Juice (Mango passion)', price: 4000, description: 'Refreshing fruit juice', category: 'drinks' },
  { name: 'Soda', price: 1000, description: 'Chilled soft drink', category: 'drinks' },
  { name: 'Water', price: 1000, description: 'Bottled water', category: 'drinks' },
];

export const formatPrice = (price) => {
  if (price === null || price === undefined) return 'Custom';
  return `TZS ${price.toLocaleString()}`;
};

export const testimonials = [
  {
    id: 1,
    name: 'Amina Rashid',
    rating: 5,
    text: 'Ordered a wedding cake for my sister and it was absolutely stunning! The team at MKD Bakery really listened to our vision and delivered beyond our expectations. Highly recommend for special occasions!',
    date: 'July 2026'
  },
  {
    id: 2,
    name: 'Charles Ngowi',
    rating: 5,
    text: 'Best bakery in Tegeta! The Friday cake rojo is amazing value, and their sambusas are always fresh and crispy. My whole family loves this place.',
    date: 'June 2026'
  },
  {
    id: 3,
    name: 'Neema Hassan',
    rating: 5,
    text: 'The bento cupcakes I ordered for my office party were a hit! Beautiful presentation and delicious taste. Will definitely be ordering again for our next event.',
    date: 'May 2026'
  },
  {
    id: 4,
    name: 'Joseph Mwakasege',
    rating: 5,
    text: 'MKD Bakery never disappoints! The birthday cake they made for my son was exactly what we wanted. Great customer service and fair prices. This is our go-to bakery now.',
    date: 'March 2026'
  },
  {
    id: 5,
    name: 'Salma Khamis',
    rating: 5,
    text: 'Their chai latte and fresh mandazi combo is perfect for breakfast! The staff are always friendly and the quality is consistently excellent. Thank you MKD!',
    date: 'February 2026'
  },
  {
    id: 6,
    name: 'Michael Temba',
    rating: 5,
    text: 'Just had their banana bread and it was heavenly! Moist, flavorful, and not too sweet. The perfect treat with afternoon coffee. Keep up the great work!',
    date: 'January 2026'
  },
];

export const businessInfo = {
  name: 'MKD Bakery',
  tagline: 'Freshly baked happiness every day',
  rating: 5.0,
  address: 'Tegeta Nyaishozi, Bagamoyo Rd, Dar es Salaam, Tanzania',
  phone: '+255 675 530 889',
  whatsapp: '255675530889',
  hours: 'Open daily until 9:00 PM - Except Mondays',
  services: ['Dine-in', 'Takeaway', 'Delivery'],
  orderApp: 'Msosi',
  instagram: 'https://www.instagram.com/mkdbakery_tz/',
  youtube: 'https://www.youtube.com/c/MKDrecipes',
};
